import {Slider, Tooltip, styled} from '@mui/material';
import PropTypes from 'prop-types';
import React, {memo, useState} from 'react';

const StyledSlider = styled(Slider)(({theme}) => ({
  marginBottom: 0,
  padding: '20px 0px',
  '& .MuiSlider-markLabel': {
    color: theme.palette.common.white,
  },
  minWidth: 100,
}));

function ValueLabelComponent(props) {
  const {children, open, value} = props;
  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
};

const SliderFilter = ({
  initialValue,
  defaultValue,
  id,
  valueLabelFormat,
  onChangeCommitted,
  ...props
}) => {
  const [internalValue, setInternalValue] = useState(initialValue);
  const handleChange = (event, newValue) => setInternalValue(newValue);
  const handleCommit = (event, newValue) => onChangeCommitted(id, newValue);

  return (
    <StyledSlider
      components={{ValueLabel: ValueLabelComponent}}
      valueLabelDisplay="on"
      {...props}
      value={internalValue}
      id={id}
      valueLabelFormat={valueLabelFormat}
      onChange={handleChange}
      onChangeCommitted={handleCommit}
    />
  );
};

SliderFilter.defaultProps = {
  defaultValue: [0, 100],
  valueLabelFormat: value => value,
};

SliderFilter.propTypes = {
  initialValue: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  id: PropTypes.string.isRequired,
  onChangeCommitted: PropTypes.func.isRequired,
  valueLabelFormat: PropTypes.func,
};

export default memo(SliderFilter);
